import ActionButton from 'components/ActionButton';
import { tableStyles } from 'css/tableStyles';
import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import {  fetchAllUnits } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import { deleteUnit } from 'services/api/units';
import EditActionForTable from 'components/EditActionForTableData';
import DeleteActionForTable from 'components/DeleteActionForTableData';

const UnitsList = props => {
  const [units, setUnits] = useState<Record<string, any>[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchUnitsFn = async () => {
    try {
      const response = await fetchAllUnits();
      setUnits(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnitsFn();
  }, []);
  
  const deleteUnitFn = async (id: string) => {
    setLoading(true);
    try {
      await deleteUnit(id);
      await fetchUnitsFn();
      showSuccess(`Unit deleted successfully`);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(() => [
    {
      name: 'Unit ID',
      selector: 'objectId',
      sortable: false,
      width: '150px',
    },
    {
      name: 'Description',
      selector: 'description',
      sortable: true,
    },
    {
      name: 'En Description',
      selector: 'enDescription',
      sortable: true,
    },
    {
      name: 'Action',
      selector: '',
      sortable: true,
      width: '300px',
      // eslint-disable-next-line react/display-name
      cell: (row: Record<string, any>) => {
        return (
          <div className={'d-flex align-items-center'}>
            <div className='mr-2 ml-0'>
              <EditActionForTable onClick={()=>{
                props.history.push(`/units/edit/${row.objectId}`);
              }} />
            </div>
            <div className='mx-3'>
              <DeleteActionForTable
                onClick={() => deleteUnitFn(row?.objectId)}
              />
            </div>
          </div>
        );
      },
    },
  ], [units]);

  return (
    <div>
      <div className={styles['header']}>
        <div className={styles['heading']}>Units</div>
        <ActionButton
          text={<>Unit <span>+</span></>}
          active={true}
          isLoading={false}
          onClick={() => props.history.push('/units/create')}
        />
      </div>
      <DataTable
        keyField="objectId"
        columns={columns}
        noHeader={true}
        data={units}
        highlightOnHover={true}
        defaultSortField="createdAt"
        customStyles={tableStyles}
        pagination={false}
        loading={loading}
      />
    </div>
  );
};

export { UnitsList };